import { render, staticRenderFns } from "./YedeerStepPhone.vue?vue&type=template&id=9160bc52&scoped=true&"
import script from "./YedeerStepPhone.vue?vue&type=script&lang=js&"
export * from "./YedeerStepPhone.vue?vue&type=script&lang=js&"
import style0 from "./YedeerStepPhone.vue?vue&type=style&index=0&id=9160bc52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9160bc52",
  null
  
)

export default component.exports